/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import PageLayout from '../../components/PageLayout';
import BotVersionForm from '../../components/bots/BotVersionForm'; // Import the form

const CreateBotVersionPage = () => {
  const { botId } = useParams(); // Still need botId for BotVersionForm

  // The page title can be simplified as the bot name fetching is no longer needed here.
  const pageTitle = "Create New Bot Version";

  return (
    <PageLayout
      title={pageTitle}
      backButton={{ label: 'Back to Bot', to: `/bots/${botId}`, preferHistory: false, hideLabelOnMobile: true }}
    >
      <BotVersionForm /> {/* botId is picked up by useParams within BotVersionForm */}
    </PageLayout>
  );
};

export default CreateBotVersionPage;
